import React, { useEffect, useState } from "react";
import WordsContainer from "./WordsContainer";
import Goals from "./Goals";
import Card from "react-bootstrap/Card";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import GameStart from "../../utils/GameStart";
import BackToGameList from "../../utils/BackToGameList";
import { HTML5Backend } from 'react-dnd-html5-backend'

function PhraseSort() {
  //settings
  const [timer, setTimer] = useState();
  const [errorChecking, setErrorChecking] = useState(true);
  const [allowImages, setAllowImages] = useState(false);
  //game start variables
  const [triggerTimer, setTriggerTimer] = useState();
  const [time, setTime] = useState(0);
  const [play, setPlay] = useState(false);
  const [resetGame, setResetGame] = useState(0);
  const [timesPlayed, setTimesPlayed] = useState(0);
  const [openGameStartModal, setOpenGameStartModal] = useState();
  //page variables
  const [words, setWords] = useState([]);
  const [phrase, setPhrase] = useState({
    id: "",
    answer: "",
    phrase: "",
  });
    const [dndEngine, setDNDEngine] = useState();
    const [dndEngineReady, setDNDEngineReady] = useState(false);

  const handleGetData = async () => {
    const response = await makeGetRequest(
      urls.phraseSort + "?active=True",
      "",
      true
    );
    const rnd = Math.floor(Math.random() * response.data.length);

    setPhrase({
      id: response.data[rnd].id,
      answer: response.data[rnd].answer,
      phrase: response.data[rnd].phrase,
    });
  };

  /**
  const handleSettings = async () => {
    const response = await makeGetRequest(
      urls.activitiesUserSettings,
      "",
      true
    );
    const settings = response.data[0];
    setAllowImages(settings.allow_images);
    setTimer(settings.timer);
    setErrorChecking(settings.error_checking);
  };
 */
  const handleResetGame = () => {
    window.location.reload();
  };

  const setEngine = () => {
    if(phrase.phrase != undefined && phrase.phrase != "" && words != 0){
      if(('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0)){
      setDNDEngine(<DndProvider backend={TouchBackend}>
                    <Card style={{ padding: "10px", margin: "10px", marginTop: "50px" }}>
                      <Goals
                        words={words}
                        phrase={phrase.phrase}
                        answer={phrase.answer}
                        setPlay={setPlay}
                        errorChecking={errorChecking}
                        setTimesPlayed={setTimesPlayed}
                      />
                      <WordsContainer words={words.sort((a, b) => a.id - b.id)} />
                    </Card>
                  </DndProvider>)
      setDNDEngineReady(true)
     }else{
      setDNDEngine(<DndProvider backend={HTML5Backend}>
                    <Card style={{ padding: "10px", margin: "10px", marginTop: "50px" }}>
                      <Goals
                        words={words}
                        phrase={phrase.phrase}
                        answer={phrase.answer}
                        setPlay={setPlay}
                        errorChecking={errorChecking}
                        setTimesPlayed={setTimesPlayed}
                      />
                      <WordsContainer words={words.sort((a, b) => a.id - b.id)} />
                    </Card>
                  </DndProvider>)
      setDNDEngineReady(true)
     };
     setDNDEngineReady(false)
    }
  }

  useEffect(() => {
    if (phrase.answer !== "") {
      phrase.answer.split(" ").map((word) => {
        setWords((prevWords) => [
          ...prevWords,
          {
            id: Math.random(),
            word: word,
          },
        ]);
      });
    }
  }, [phrase]);

  useEffect(() => {
    if (words.length === 0) {
      handleGetData();
      //handleSettings();
    }
  }, []);

  useEffect(() => {
    if (timesPlayed > 0) {
      setOpenGameStartModal(true);
    }
  }, [timesPlayed]);

  useEffect(() => {
    if (resetGame === 1) {
      handleResetGame();
    }
  }, [resetGame]);

  useEffect(() => {
    if(dndEngine === undefined && (phrase.phrase != undefined && phrase.phrase != '')){
      setEngine()
    }
  },[words])

    return (
      <>
      {!dndEngineReady ? <>
                      <BackToGameList />
                      <div
                        className="main-content"
                        style={{ margin: "20px", background: "rgb(240, 244, 249)" }}
                      >
                        <GameStart
                          timer={timer}
                          time={time}
                          play={play}
                          setTime={setTime}
                          openGameStartModal={openGameStartModal}
                          timesPlayed={timesPlayed}
                          setResetGame={setResetGame}
                          onGameStartModal={setOpenGameStartModal}
                          gameTitle={"Phrase Sorts"}
                          gameDescription={`To play, touch the "Start Game" button. 
                          Then touch and drag words into the phrase that matches the description.
                          Thank you for playing, and enjoy!`} />
                        {dndEngine}
                      </div>
                      </> : <>Loading...</>}
                    </>
      )
}

export default PhraseSort;
